import { render, staticRenderFns } from "./PedidosProveedor.vue?vue&type=template&id=91dc69e4&"
import script from "./PedidosProveedor.vue?vue&type=script&lang=js&"
export * from "./PedidosProveedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports